import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {BLAST_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {BLASTOperator} from 'search/SearchConstants';

export enum BLASTInputSource {
  FileUpload = 'file_upload',
  TextInput = 'text_input',
  BenchlingEntity = 'benchling_entity',
  Selection = 'selection',
}

export function trackBlastSubmission(blastOperator: BLASTOperator, inputs: Set<BLASTInputSource>): void {
  analytics.trackEvent(BLAST_ANALYTICS_ACTIONS.SUBMITTED_BLAST_SEARCH, {
    algorithm: blastOperator,
    input_source: _.sortBy(Array.from(inputs)),
  });
}

export enum BlastModalTrigger {
  // when the modal is opened from the global search
  BLAST_SEARCH = 'BLAST_SEARCH',
  // when the modal is opened from the sequence selection context menu
  SELECTION = 'SELECTION',
}

export function trackBlastModalOpen(source: BlastModalTrigger): void {
  analytics.trackEvent(BLAST_ANALYTICS_ACTIONS.OPENED_BLAST_MODAL, {
    source,
  });
}

export function trackBlastModalClose(source: BlastModalTrigger, step: string): void {
  analytics.trackEvent(BLAST_ANALYTICS_ACTIONS.CLOSED_BLAST_MODAL, {
    source,
    step,
  });
}

export enum BlastSearchView {
  TABLE = 'TABLE',
  ALIGNMENT = 'ALIGNMENT',
}

export function trackBlastTableAlignmentViewSwitch(view: BlastSearchView): void {
  analytics.trackEvent(BLAST_ANALYTICS_ACTIONS.SWITCHED_TABLE_ALIGNMENT_VIEW, {
    view,
  });
}

export enum BlastAlignmentView {
  BAR = 'BAR',
  PAIRWISE = 'PAIRWISE',
}

export enum BlastAlignmentViewSwitchTrigger {
  // when the user explicitly clicks the toggle button
  CLICK = 'CLICK',
  // when the switch is triggered automatically due to zooming
  ZOOM = 'ZOOM',
}

export function trackBlastBarPairwiseViewSwitch(
  view: BlastAlignmentView,
  trigger: BlastAlignmentViewSwitchTrigger
): void {
  analytics.trackEvent(BLAST_ANALYTICS_ACTIONS.SWITCHED_BAR_PAIRWISE_VIEW, {
    view,
    trigger,
  });
}
